import { PersonaId, PersonaConfig } from './types';
import { standardForecastPersona } from './definitions/standard_forecast';
import { generalPersona } from './definitions/general';
import { photographyPersona } from './definitions/photography';
import { stargazingPersona } from './definitions/stargazing';
import { winterSportsPersona } from './definitions/wintersports';
import { hikingPersona } from './definitions/hiking';
import { waterSportsPersona } from './definitions/watersports';
import store from '../state';

export const ALL_PERSONAS: Record<PersonaId, PersonaConfig> = {
  standard_forecast: standardForecastPersona,
  general: standardForecastPersona,
  photography: photographyPersona,
  stargazing: stargazingPersona,
  wintersports: winterSportsPersona,
  hiking: hikingPersona,
  watersports: waterSportsPersona,
};

export function getPersona(id: PersonaId): PersonaConfig {
  return ALL_PERSONAS[id] || ALL_PERSONAS['standard_forecast'] || generalPersona;
}

export function getActivePersona(): PersonaConfig {
  const activeId = store.getState().activePersona || 'standard_forecast';
  return getPersona(activeId);
}

export function setActivePersona(id: PersonaId): void {
  if (ALL_PERSONAS[id]) {
    try {
      localStorage.setItem('gw_active_persona', id);
    } catch (e) {
      console.warn('Could not save persona to localStorage:', e);
    }
    // Base resets for all state elements across persona switches
    const updateObj: any = {
      activePersona: id,
      primaryProduct: null,
      precipAccumEnabled: false,
      liveWeatherQpeMode: 'off',
      cloudsEnabled: false,
      windsEnabled: false,
      smokeEnabled: false,
      streamflowEnabled: false,
      snowDepthEnabled: false,
      wildfiresEnabled: false,
      fireRestrictionsEnabled: false,
      avalancheEnabled: false,
      webcamsEnabled: false,
      liveWeatherRadarEnabled: false,
      liveWeatherSatelliteEnabled: false,
      liveWeatherTempGradientEnabled: false,
      wxStationsEnabled: false,
      liveWeatherSunIntensityEnabled: false,
      liveWeatherRtmaWindsEnabled: false,
      liveWeatherAqiStationsEnabled: false,
      auroraEnabled: false,
      milkyWayLineEnabled: false,
      milkyWayArEnabled: false,
      sunMoonArEnabled: false,
      showMoonAngles: false,
      activeLayerProducts: {}
    };

    store.update(updateObj);
  }
}
